export const FIND_MEAL_CATEGORIES_FAILURE = 'FIND_MEAL_CATEGORIES_FAILURE';

export const findMealCategoriesFailure = ( payload: Error ) => ({
    type: FIND_MEAL_CATEGORIES_FAILURE,
    payload,
});